import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const nebulaManagementFeeMenuRegistry = {
    personalize_nebulaManagementFee: {
        label: "Nebula Management Fee",
        link: PAGE_URL.NEBULA_MANAGEMENT_FEE_PAGE,
        key: PAGE_URL.NEBULA_MANAGEMENT_FEE_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default nebulaManagementFeeMenuRegistry;
